<template>
  <v-card
    class="d-flex flex-column secondary--text justify-center"
    min-height="550"
  >
    <div
      class="pa-10 d-flex flex-column align-center"
      style="min-height: 500px"
    >
      <i :class="`icofont-exclamation-circle icofont-6x accent--text`" />

      <div
        class="mb-4 custom-title secondary--text font-weight-medium text-center"
      >
        Important Note
      </div>
      <div class="text-left px-4">{{ bodyText }}</div>
    </div>
    <div>
      <v-btn
        depressed
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent_light"
        @click="close"
      >
        <span class="" style="font-weight: 600 !important">CANCEL</span>
      </v-btn>
      <v-btn
        depressed
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent"
        @click="next"
      >
        <span class="" style="font-weight: 600 !important">CONTINUE</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ImportantNoteDialog",
  components: {},
  props: {
    bodyText: {
      type: String,
      default: "This is an upcoming feature.",
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close:dialog");
    },
    next() {
      this.$emit("continue");
    },
  },
};
</script>

<style></style>
